export const SiteFooter = () => {
  return (
    <footer
      className="border-t-2 border-black bg-white"
      data-testid="site-footer"
    >
      <div className="mx-auto grid w-full max-w-6xl gap-8 px-6 py-12 md:grid-cols-3">
        <div className="space-y-4">
          <h3
            className="text-xl font-bold uppercase tracking-[0.2em]"
            data-testid="footer-brand-title"
          >
            Custom Box Lab
          </h3>
          <p className="text-sm text-muted-foreground" data-testid="footer-brand-copy">
            Precision engineered packaging for modern brands. From dielines to delivery, we keep
            production tight and lead times tight.
          </p>
        </div>
        <div className="space-y-3">
          <p className="text-xs font-semibold uppercase tracking-[0.3em]" data-testid="footer-lab-label">
            Production Lab
          </p>
          <p className="text-sm" data-testid="footer-lab-address">
            1380 Industrial Park Drive · Edmore, MI 48829
          </p>
          <p className="text-sm" data-testid="footer-lab-hours">
            Mon - Fri · 7:00 AM – 7:00 PM PST
          </p>
        </div>
        <div className="space-y-3">
          <p
            className="text-xs font-semibold uppercase tracking-[0.3em]"
            data-testid="footer-support-label"
          >
            Support Desk
          </p>
          <p className="text-sm" data-testid="footer-support-phone">
            989-565-2355
          </p>
          <p className="text-sm" data-testid="footer-support-email">
            sales@tailoredpackaging.net
          </p>
        </div>
      </div>
      <div className="border-t-2 border-black px-6 py-4 text-center text-xs uppercase tracking-[0.3em] text-muted-foreground">
        <span data-testid="footer-copyright">
          © 2024 Custom Box Lab · Built for high-volume packaging teams
        </span>
      </div>
    </footer>
  );
};